import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FiMail } from "react-icons/fi";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import { Alert, Button, Form, Input, Typography } from "antd";
import { setHtmlStorage } from "../../config/helper";
import * as actionAuth from "../../store/auth/action";
import styles from "./forgot.module.css";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertShow: false,
      alertVariant: "error",
      alertMessage: "",
      email: "",
    };
    this.handleSignUpForm = this.handleSignUpForm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleSignUpForm = async () => {
    const payload = {
      data: JSON.stringify({
        email: this.state.email,
      }),
    };

    await this.props.authForgot(payload);

    if (this.props.forgotResponse.httpStatus === 200) {
      setHtmlStorage("forgot-email", this.state.email);
      setHtmlStorage("forgot-message", this.props.forgotResponse.data);
      window.location.href = "/forgot-password/success";
    } else {
      this.setState({
        alertShow: true,
        alertVariant: "error",
        alertMessage: this.props.forgotResponse.data,
      });
    }
  };

  handleInputChange = (evt) => {
    const { name, value } = evt.target;
    this.setState({ [name]: value });
  };

  render() {
    return (
      <div className={styles.auth_forgot_page}>
        <div className={styles.auth_wrapper}>
          <Link to="/signin" className={styles.btn_back_login}>
            <HiOutlineArrowSmallLeft style={{ fontSize: 24 }} />
          </Link>
          <Typography.Title level={3} className={styles.auth_forgot_title}>
            Forgot Password
          </Typography.Title>
          <Typography.Text className={styles.auth_forgot_desc}>
            Enter the email associated with your account
          </Typography.Text>
          {this.state.alertShow && (
            <Alert
              type={this.state.alertVariant}
              message={this.state.alertMessage}
              closable
              onClose={() => this.setState({ alertShow: false })}
            />
          )}
          <Form
            colon={false}
            autoComplete="off"
            layout="vertical"
            onFinish={this.handleSignUpForm}
          >
            <Form.Item>
              <Input
                required
                type="email"
                placeholder="Email"
                name="email"
                prefix={<FiMail />}
                value={this.state.email}
                onChange={this.handleInputChange}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={this.props.loading}
                disabled={this.props.loading}
                type="primary"
                htmlType="submit"
                className={styles.btn_forgot_password}
              >
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => {
  const { auth } = state;
  return {
    loading: auth.loading,
    forgotResponse: auth.forgotResponse,
  };
};

const dispatchToProps = (dispatch) => ({
  authForgot: (payload) => dispatch(actionAuth.authForgot(payload)),
});

export default connect(stateToProps, dispatchToProps)(ForgotPassword);
